import React, { useEffect, useState } from "react";
import axios from "axios";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { BiSad } from "react-icons/bi";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";

const LeaveAlertsCards = () => {
  const [leaveData, setLeaveData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchLeaveAlerts = async () => {
    const patient_id = location.state?.student_id;
    if (!patient_id) return;
    try {
      const response = await axios.post(
        "https://www.careplus.gopillz.com/leave-alerts",
        JSON.stringify({ patient_id }),
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );
      setLeaveData(response.data);
    } catch (err) {
      console.error("Failed to fetch leave data", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveAlerts();
  }, []);

  const getStatusBadge = (status, label) => {
    const icon = status ? (
      <FaCheckCircle className="text-green-600" />
    ) : (
      <FaTimesCircle className="text-yellow-500" />
    );
    const color = status ? "text-green-700" : "text-yellow-600";
    const text = status ? "Approved" : "Pending";

    return (
      <div className="flex items-center gap-2 text-sm">
        {icon}
        <span className={`font-semibold ${color}`}>
          {label}: {text}
        </span>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-blue-50">
        <p className="text-xl text-gray-600 animate-pulse">Loading leave records...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-teal-50">
      <div className="fixed top-0 left-0 right-0 z-50 bg-white shadow">
        <Navbar />
      </div>

      <div className="max-w-7xl mx-auto px-6 pt-28 pb-12">
        <h2 className="text-4xl font-extrabold text-center text-indigo-800 mb-12 tracking-wide">
          🧾 Student Leave Records
        </h2>

        {leaveData.length === 0 ? (
          <div className="flex flex-col items-center justify-center text-gray-500 pt-20">
            <BiSad className="text-6xl mb-4 text-gray-400" />
            <p className="text-lg font-medium">No leave data found</p>
          </div>
        ) : (
          <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {leaveData.map((item, index) => (
              <div
                key={index}
                className="bg-white border border-gray-200 rounded-2xl shadow-lg p-6 hover:shadow-2xl transition-all"
              >
                <div className="mb-4 space-y-1">
                  <h3 className="text-xl font-bold text-gray-800">
                    {item.patient_name || "Unnamed"}
                    <span className="ml-2 text-sm text-gray-500 font-medium">
                      ({item.roll_number || "N/A"})
                    </span>
                  </h3>
                  <p className="text-sm text-gray-700">
                    <strong className="text-emerald-600">Leave Type:</strong> {item.leave_type || "—"}
                  </p>
                  <p className="text-sm text-gray-700">
                    <strong className="text-indigo-600">Duration:</strong> {item.from_date} → {item.to_date}
                  </p>
                  <p className="text-sm text-gray-700">
                    <strong className="text-rose-500">Reason:</strong> <i>{item.reason || "—"}</i>
                  </p>
                </div>

                <div className="mt-4 pt-4 border-t space-y-2">
                  {getStatusBadge(item.leave_approval_status_by_doctor, "Doctor")}
                  {getStatusBadge(item.leave_approval_status_by_parent, "Parent")}
                  {getStatusBadge(item.leave_approval_status_by_warden, "Warden")}
                  {getStatusBadge(item.leave_approval_status_by_medical_officer, "Medical Officer")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default LeaveAlertsCards;
